/// Mirrors the canonical self check-in mood template (shore
/// self-check-in.questions.ts: ids great/good/okay/low/struggling). Shared by
/// pulse-surveys and mood-insights so any vocabulary drift stays visible.
export const MOOD_DISPLAY = {
  great: { emoji: "\u{1F604}", label: "Great" },
  good: { emoji: "\u{1F642}", label: "Good" },
  okay: { emoji: "\u{1F610}", label: "Okay" },
  low: { emoji: "\u{1F615}", label: "Low" },
  struggling: { emoji: "\u{1F61E}", label: "Struggling" },
} as const;

export type MoodOptionId = keyof typeof MOOD_DISPLAY;

export const MOOD_OPTIONS = Object.entries(MOOD_DISPLAY).map(([id, display]) => ({
  id: id as MoodOptionId,
  emoji: display.emoji,
  label: display.label,
})) as Array<{ id: MoodOptionId; emoji: string; label: string }>;

export const MOOD_FOLLOW_UPS: Record<MoodOptionId, { id: string; text: string }> = {
  great: {
    id: "great-follow-up",
    text: "Love the energy. What made today click? Worth bottling?",
  },
  good: {
    id: "good-follow-up",
    text: "Nice. What's one thing going well right now?",
  },
  okay: {
    id: "okay-follow-up",
    text: "Steady day. What's one small thing that would make tomorrow a bit better?",
  },
  low: {
    id: "low-follow-up",
    text: "Thanks for checking in. What's weighing on you? Share as much or little as you like.",
  },
  struggling: {
    id: "struggling-follow-up",
    text: "That sounds tough. What would help most right now, or who could?",
  },
};

export const MOOD_AFFIRMATIONS: Record<MoodOptionId, string> = {
  great: "Glad today has some lift in it. Let's capture what is working.",
  good: "Nice to hear. A quick note now can help you spot the pattern later.",
  okay: "Thanks for checking in. Small signals still matter.",
  low: "Thanks for sharing this. Even a few words can help surface what needs care.",
  struggling: "You're not carrying this alone. Share only what feels helpful right now.",
};

export function moodFromFollowUpId(followUpId: string | undefined): MoodOptionId | null {
  if (!followUpId) return null;

  for (const [mood, followUp] of Object.entries(MOOD_FOLLOW_UPS)) {
    if (followUp.id === followUpId) {
      return mood as MoodOptionId;
    }
  }

  return null;
}
